import { Component, Fragment } from "react";
import { connect } from 'react-redux';
import { exibeMensagemErro, limpaMensagem } from "../../providers/actions";

import './Home.css';
import { AnonimousPanel } from "./AnonimousPanel";

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
	}
}

const mapDispatchToProps = { exibeMensagemErro, limpaMensagem }

export const HomeAnonimous =

// redux
connect(
	(mapStateToProps), 
	(mapDispatchToProps)
)(
	class extends Component {

		render() {
			return (
				<Fragment>
					<AnonimousPanel/>
				</Fragment>
			);
		}
	}
); // router